import { apiHelper } from '@/utils';
import { API } from '@/constants';

export const companyService = {
    getAll,
    store,
    show,
    update,
    updateStatus,
    softDelete,
    destroy,
};

const MODULE = {
    COMPANY: 'companies',
};

const API_URL = API.BASE_URL_API + '/v1';

export function getAll (filter) {
    const request = {
        params: {
            parent_company: filter?.parentCompany,
            group: filter?.group,
            company_type: filter?.companyType,
            page: filter?.pageNumber,
            size: filter?.pageSize,
            is_active: filter?.isActive,
        },
    };

    let array = filter?.searchArray;
    array?.forEach((word, index) => {
        if (word != null || word != '') {
            var searchParam = `search_words[${index}]`;
            request.params[searchParam] = word;
        }
    });

    return apiHelper(API_URL).get(`/${MODULE.COMPANY}`, request);
}

export function store (data) {
    if (!(data.logo instanceof File)) {
        return apiHelper(API_URL).post(`/${MODULE.COMPANY}`, companyPayload(data), { headers: { "Content-Type": "application/json" } });
    }
    const formData = new FormData();
    formData.append(`name`, data.name);
    if (data.groupUUID) formData.append(`group_uuid`, data.groupUUID);
    if (data.companyTypeUUID) formData.append(`company_type_uuid`, data.companyTypeUUID);
    if (data.parentCompanyUUID) formData.append(`parent_company_uuid`, data.parentCompanyUUID);
    if (data.displayName) formData.append(`display_name`, data.displayName);
    if (data.intro) formData.append(`intro`, data.intro);
    if (data.description) formData.append(`description`, data.description);
    if (data.stockCode) formData.append(`stock_code`, data.stockCode);
    if (data.colorCode) formData.append(`color_code`, data.colorCode);
    if (data.websiteUrl) formData.append(`website_url`, data.websiteUrl);
    if (data.email) formData.append(`email`, data.email);
    if (data.phoneCode) formData.append(`phone_code`, data.phoneCode);
    if (data.phoneNumber) formData.append(`phone_number`, data.phoneNumber);
    if (data.phoneIso) formData.append(`phone_iso`, data.phoneIso);
    if (data.isListed != null) formData.append(`is_listed`, data.isListed);
    if (data.logo instanceof File) formData.append('logo', data.logo);
    (data.departmentUuids ?? []).filter(item => item).forEach(item => {
        formData.append(`department_uuids[]`, item);
    });
    (data.officeUuids ?? []).filter(item => item).forEach(item => {
        formData.append(`office_uuids[]`, item);
    });
    (data.companyServices ?? []).filter(item => item).forEach(item => {
        formData.append(`company_services[]`, item);
    });

    return apiHelper(API_URL).post(`/${MODULE.COMPANY}`, formData);
}

export function show (uuid) {
    return apiHelper(API_URL).get(`/${MODULE.COMPANY}/${uuid}`);
}

export function companyPayload(data) {
    return {
        group_uuid: data.groupUUID ?? null,
        company_type_uuid: data.companyTypeUUID ?? null,
        parent_company_uuid: data.parentCompanyUUID ?? null,
        name: data.name,
        display_name: data.displayName ?? "",
        description: data.description ?? "",
        intro: data.intro ?? "",
        stock_code: data.stockCode ?? "",
        color_code: data.colorCode ?? "",
        website_url: data.websiteUrl ?? "",
        email: data.email ?? "",
        phone_code: data.phoneCode ?? "",
        phone_iso: data.phoneIso ?? "",
        phone_number: data.phoneNumber ?? "",
        is_listed: [true, 1, "1"].includes(data.isListed),
        department_uuids: [...new Set((data.departmentUuids ?? []).filter(Boolean))],
        office_uuids: [...new Set((data.officeUuids ?? []).filter(Boolean))],
        company_services: (data.companyServices ?? []).filter(item => typeof item === "string" && item.trim()),
    };
}

export function update (data) {
    if (!(data.logo instanceof File)) {
        return apiHelper(API_URL).put(`/${MODULE.COMPANY}/${encodeURIComponent(data.uuid)}`, companyPayload(data), { headers: { "Content-Type": "application/json" } });
    }
    const formData = new FormData();
    formData.append(`_method`, 'PUT');
    formData.append(`name`, data.name);

    if (data.groupUUID != null) formData.append(`group_uuid`, data.groupUUID);
    if (data.companyTypeUUID != null) formData.append(`company_type_uuid`, data.companyTypeUUID);
    if (data.parentCompanyUUID != null) formData.append(`parent_company_uuid`, data.parentCompanyUUID);
    if (data.displayName != null) formData.append(`display_name`, data.displayName);
    if (data.intro != null) formData.append(`intro`, data.intro);
    if (data.description != null) formData.append(`description`, data.description);
    if (data.stockCode != null) formData.append(`stock_code`, data.stockCode);
    if (data.colorCode != null) formData.append(`color_code`, data.colorCode);
    if (data.websiteUrl != null) formData.append(`website_url`, data.websiteUrl);
    if (data.email != null) formData.append(`email`, data.email);
    if (data.phoneCode != null) formData.append(`phone_code`, data.phoneCode);
    if (data.phoneNumber != null) formData.append(`phone_number`, data.phoneNumber);
    if (data.phoneIso != null) formData.append(`phone_iso`, data.phoneIso);
    if (data.isListed != null) formData.append(`is_listed`, data.isListed);
    if (data.logo instanceof File) formData.append('logo', data.logo);
    (data.departmentUuids ?? []).filter(item => item).forEach(item => {
        formData.append(`department_uuids[]`, item);
    });
    (data.officeUuids ?? []).filter(item => item).forEach(item => {
        formData.append(`office_uuids[]`, item);
    });
    (data.companyServices ?? []).filter(item => item).forEach(item => {
        formData.append(`company_services[]`, item);
    });
    
    return apiHelper(API_URL).post(`/${MODULE.COMPANY}/${data.uuid}`, formData);
}

export function updateStatus (data) {
    const request = {
        is_active: data.isActive,
    };

    return apiHelper(API_URL).patch(`/${MODULE.COMPANY}/status/${data.uuid}`, request);
}

export function softDelete (data) {
    return apiHelper(API_URL).patch(`/${MODULE.COMPANY}/delete/${data.uuid}`, data);
}

export function destroy (data) {
    return apiHelper(API_URL).delete(`/${MODULE.COMPANY}/${data.uuid}`);
}